import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import ScheduleInterviewModal from '../ScheduleInterviewModal';
import { putRequest, getRequest } from '../../requestUtils';
import './ConfirmModal.scss';

class ConfirmModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showConfirmModal: false,
      showInterviewModal: false,
      reasons: [],
      internalNotes: '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInterviewModalClose = this.handleInterviewModalClose.bind(this);
  }

  componentDidMount() {
    const { statusChangeId } = this.props;

    if (!statusChangeId) return;

    getRequest(`/status_changes/${statusChangeId}`).then((response) => {
      this.setState({
        reasons: response.data.internal_feedbacks,
        internalNotes: response.data.change_reason,
      });
    });
  }

  handleInterviewModalClose() {
    this.setState({ showInterviewModal: false });
  }

  handleSubmit() {
    const {
      type,
      csrfToken,
      submitUrl,
      isEditing,
      statusChangeId,
      handleProposalAfterSubmit,
    } = this.props;
    const { reasons, internalNotes } = this.state;

    if (type === 'interview' && !isEditing) {
      this.setState({ showConfirmModal: false, showInterviewModal: true });
      return;
    }

    const url = isEditing ? `/status_changes/${statusChangeId}` : submitUrl;
    let params;

    if (isEditing) {
      params = {
        status_change: {
          change_reason: internalNotes,
          internal_feedback_ids: reasons.map((reason) => reason.value),
        },
      };
    } else {
      params = {
        reason: internalNotes,
        internal_feedback_ids: reasons.map((reason) => reason.value),
      };
    }

    putRequest(
      url,
      params,
      csrfToken,
    ).then(({ data }) => {
      this.setState({ showConfirmModal: false });
      handleProposalAfterSubmit(data);
    }).catch(() => null);
  }

  renderScheduleInterviewModal() {
    const {
      submitUrl,
      csrfToken,
      proposalResourceId,
      consultantName,
      possibleInterviewers,
      invitableRoles,
      newInterviewSlot,
      availableInterviewSlotUrl,
    } = this.props;
    const { reasons, internalNotes } = this.state;

    return (
      <ScheduleInterviewModal
        createInterviewUrl={submitUrl}
        proposalResourceId={proposalResourceId}
        csrfToken={csrfToken}
        consultantName={consultantName}
        possibleInterviewers={possibleInterviewers}
        invitableRoles={invitableRoles}
        modalTriggerType="link"
        showModal
        reasons={reasons.map((reason) => reason.value)}
        internalNotes={internalNotes}
        showModalTrigger={false}
        newInterviewSlot={newInterviewSlot}
        availableInterviewSlotUrl={availableInterviewSlotUrl}
        handleInterviewModalClose={this.handleInterviewModalClose}
      />
    );
  }

  renderModalHeading() {
    const { type } = this.props;

    const text = type === 'interview' ? 'interview request' : type;

    return (
      <h2 className="mb-3">
        Confirm
        {' '}
        {text}
      </h2>
    );
  }

  renderDropdown() {
    const { type, reasonOptions } = this.props;
    return (
      <div className="body-text-2 mt-3">
        <div className="required">
          Indicate primary reason(s) employer would like to
          {' '}
          {type}
          {' '}
          this candidate:
        </div>
        <Select
          classNamePrefix="clora-multiselect"
          closeMenuOnSelect={false}
          value={this.state.reasons || []}
          isMulti
          className="reason-select mt-3"
          onChange={(options) => this.setState({ reasons: options })}
          isDisabled={false}
          placeholder="Choose an option"
          hideSelectedOptions={false}
          options={reasonOptions}
        />
      </div>
    );
  }

  renderTextBox() {
    const { type } = this.props;

    const text = type === 'interview' ? 'interview request' : type;

    return (
      <div className="pt-3 body-text-2">
        <div className="required">
          Internal notes about
          {' '}
          {text}
          :
        </div>
        <textarea
          className="form-control fs-hide null mt-3"
          required="required"
          onChange={(e) => this.setState({ internalNotes: e.target.value })}
          value={this.state.internalNotes || ''}
        />
      </div>
    );
  }

  renderButtons() {
    const { type, isEditing } = this.props;
    const { reasons, internalNotes } = this.state;

    const disabledState = isEditing ? false : (reasons.length < 1 || internalNotes.length < 3);
    let buttonText;

    if (isEditing) {
      buttonText = 'Save';
    } else if (type === 'interview') {
      buttonText = 'Request interview';
    } else {
      buttonText = type[0].toUpperCase() + type.substring(1);
    }

    return (
      <div className="g-row mt-4 gap-20">
        <div className="g-column g-flex-6">
          <button
            className="btn btn-secondary button-back"
            onClick={this.handleBack}
          >
            Cancel
          </button>
        </div>
        <div className="g-column g-flex-6">
          <button
            className="btn btn-primary button-submit"
            onClick={this.handleSubmit}
            disabled={disabledState}
          >
            {buttonText}
          </button>
        </div>
      </div>
    );
  }

  renderModal() {
    const { showInterviewModal } = this.state;
    return (
      <div>
        <Modal
          show={this.state.showConfirmModal}
          onHide={() => this.setState({ showConfirmModal: false })}
          dialogClassName="confirm-modal"
          size="lg"
        >
          <Modal.Header closeButton />
          <div className="padded-modal-content style-guide">
            {this.renderModalHeading()}
            {this.renderDropdown()}
            {this.renderTextBox()}
            {this.renderButtons()}
          </div>
        </Modal>
        {showInterviewModal && this.renderScheduleInterviewModal()}
      </div>
    );
  }

  renderModalTrigger() {
    const { buttonType, modalTriggerCopy, modalTriggerType } = this.props;

    if (modalTriggerType === 'button') {
      return (
        <button
          className={`btn ${buttonType}`}
          onClick={() => this.setState({ showConfirmModal: true })}
        >
          {modalTriggerCopy}
        </button>
      );
    }

    return (
      <a
        role="button"
        tabIndex={0}
        className="confirm-modal-cta"
        onClick={() => this.setState({ showConfirmModal: true })}
      >
        {modalTriggerCopy}
      </a>
    );
  }

  render() {
    return (
      <div className="confirm-modal-container">
        {this.renderModalTrigger()}
        {this.renderModal()}
      </div>
    );
  }
}

ConfirmModal.propTypes = {
  submitUrl: PropTypes.string,
  proposalResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  possibleInterviewers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string.isRequired,
  reasonOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  modalTriggerType: PropTypes.oneOf(['button', 'link']),
  buttonType: PropTypes.string,
  modalTriggerCopy: PropTypes.string.isRequired,
  availableInterviewSlotUrl: PropTypes.string.isRequired,
  statusChangeId: PropTypes.number,
  isEditing: PropTypes.bool,
  newInterviewSlot: PropTypes.bool,
  handleProposalAfterSubmit: PropTypes.func,
};

ConfirmModal.defaultProps = {
  possibleInterviewers: null,
  invitableRoles: null,
  modalTriggerType: 'link',
  buttonType: 'btn-primary',
  statusChangeId: null,
  isEditing: false,
  submitUrl: '',
  handleProposalAfterSubmit: () => {},
  newInterviewSlot: false,
};

export default ConfirmModal;
